import {selectIsDarkMode} from '../../../../../config-page/src/state/selectors/global.js';
import routes from '../../../../consts/routes.js';
import uamStatusTypes from '../../../../consts/uam/uamStatusTypes.js';
import log from '../../../../services/logger/log.js';
import notificationService from '../../../../services/notificationService.js';
import uamWebSocketService from '../../../../services/uam/uamWebSocketService.js';
import {selectIsAuthorized} from '../../../../state/selectors/auth.js';
import {
    selectDeviceAvailableFirmwareVersion,
    selectDeviceFirmwareVersion,
    selectIotDeviceAssetId,
} from '../../../../state/selectors/iotDevices.js';
import {getState} from '../../../../state/store.js';
import helpers from '../../../../utils/helpers.js';
import firmwareUpdateDefaultReleaseNotesService from './firmwareUpdateDefaultReleaseNotesService.js';

const TIMEOUT_BETWEEN_STATUSES = 6; // 6 seconds
const NEW_FW_VERSION_TIMEOUT = 60 * 1000; // 1 minute

let requestId, isUpdated, timeout;

const sendProgress = (dusn, progress) => {
    const assetId = selectIotDeviceAssetId(dusn)(getState());

    uamWebSocketService.messageWS({
        eventType: 'ASYNC_REQUEST',
        status: 'PENDING',
        serialNumber: dusn,
        assetId,
        requestId,
        request: {value: {phase: 'DOWNLOAD', phaseProgress: progress}, action: 'progress'},
    });
};

const sendStatus = (dusn, status = uamStatusTypes.SUCCESS) => {
    isUpdated = true;
    const assetId = selectIotDeviceAssetId(dusn)(getState());
    const installedFWVersion = selectDeviceAvailableFirmwareVersion(dusn);

    uamWebSocketService.messageWS({
        status,
        serialNumber: dusn,
        assetId,
        requestId,
        request: {action: 'firmwareUpgrade', resultMetadata: {firmwareStatus: {installedFWVersion}}},
        eventType: 'ASYNC_REQUEST',
    });
};

const startFwuMockProcess = (dusn) => {
    for (let i = 1; i <= 20; i++) {
        setTimeout(() => sendProgress(dusn, i * 5), TIMEOUT_BETWEEN_STATUSES * (i - 1) * 1000);
    }

    setTimeout(() => {
        sendStatus(dusn);
    }, TIMEOUT_BETWEEN_STATUSES * 25 * 1000);
};

const getFirmwareUpdateAvailability = async (dusn) => {
    const isDarkMode = selectIsDarkMode(getState());
    const releaseNotes = firmwareUpdateDefaultReleaseNotesService.getFirmwareUpdateReleaseNotesMock(isDarkMode);

    // Return no available firmware if the firmware update started before
    if (isUpdated) {
        await helpers.timeout(1000);

        return {availableFirmwareVersion: null, releaseNotes};
    }

    await helpers.timeout(2000);

    const firmwareVersion = selectDeviceFirmwareVersion(dusn)(getState());
    const availableFirmwareVersion = firmwareVersion
        ? firmwareVersion.replace(/(\d+)\.(\d+)\.(\d+)/, (_, major, minor, patch) => `${major}.${+minor + 1}.${patch}`)
        : '12.1.0';

    return {availableFirmwareVersion, releaseNotes};
};

const postUpdateFirmware = (dusn) => {
    if (!requestId) {
        requestId = helpers.guid();
    }

    startFwuMockProcess(dusn);

    return requestId;
};

const showNotificationAboutNewVersion = () => {
    log.debug('Start firmware mock');

    if (timeout) {
        clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
        if (window.location.pathname.includes(routes.DEVICE_FWU)) {
            return;
        }

        const isAuthorized = selectIsAuthorized(getState());

        if (isAuthorized) {
            notificationService.showPushNotificationAboutNewFwVersion();
        }
    }, NEW_FW_VERSION_TIMEOUT);
};

export const firmwareMockService = {
    postUpdateFirmware,
    getFirmwareUpdateAvailability,
    showNotificationAboutNewVersion,
};
